(function () {
  var ERROR_MAP = {
    'This field is required': 'Este campo es obligatorio.',
    'This field is required.': 'Este campo es obligatorio.',
    'Please enter a valid email address': 'Este correo no es válido.',
    'Please enter a valid email address.': 'Este correo no es válido.',
    'This email is invalid': 'Este correo no es válido.',
    'This email is invalid.': 'Este correo no es válido.',
    'Enter a valid email address': 'Este correo no es válido.',
    'Enter a valid email address.': 'Este correo no es válido.'
  };

  function translateAlertText(node) {
    if (!node || node.nodeType !== 1) return;

    var alerts = [];
    if (node.matches && node.matches('span[role="alert"]')) {
      alerts.push(node);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('span[role="alert"]').forEach(function (el) {
        alerts.push(el);
      });
    }

    alerts.forEach(function (alert) {
      var raw = (alert.textContent || '').trim();
      if (!raw) return;
      var translated = ERROR_MAP[raw];
      if (translated && alert.textContent !== translated) {
        alert.textContent = translated;
      }
    });
  }

  function observeKlaviyo(root) {
    if (!root || root.dataset.klaviyoI18nInit === 'true') return;
    root.dataset.klaviyoI18nInit = 'true';

    translateAlertText(root);

    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && mutation.target && mutation.target.parentElement) {
          translateAlertText(mutation.target.parentElement);
        }
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            translateAlertText(node);
          });
        }
        if (mutation.type === 'attributes' && mutation.target) {
          translateAlertText(mutation.target);
        }
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-invalid', 'class', 'style']
    });
  }

  function initSection(section) {
    if (!section || section.dataset.ruBf26OutbHeroInit === 'true') return;
    section.dataset.ruBf26OutbHeroInit = 'true';

    var klaviyoRoot = section.querySelector('.section-ru-bf26-outb-hero__klaviyo');
    if (klaviyoRoot) {
      observeKlaviyo(klaviyoRoot);
    }

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var mount = section.querySelector('.section-ru-bf26-outb-hero__klaviyo');
      if (mount) {
        observeKlaviyo(mount);
        var form = mount.querySelector('form.klaviyo-form') || mount.querySelector('[data-testid^="klaviyo-form"]');
        if (form) {
          observeKlaviyo(form);
          window.clearInterval(timer);
        }
      }
      if (tries >= 40) window.clearInterval(timer);
    }, 250);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.section-ru-bf26-outb-hero').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
